import store from "@/store";
import API from "@/API";

// 予約時の自動選択がなしになったので、使用なし
export const getTargetCycleFromParkInfo = async () => {
  const park = store.getters["dbs/park"];
  const targetCycle = sortByBatteryLevel(park.cycle_info)[0];

  await API.getDbsCycle(0, targetCycle.cyc_name);
};

// バッテリーが多い順に並び替え
const sortByBatteryLevel = (cycles) => {
  if (cycles) {
    return cycles.slice().sort(function (a, b) {
      if (a.battery_level < b.battery_level) return -1;
      if (a.battery_level > b.battery_level) return 1;
      return 0;
    });
  }
};
